module.exports = __webpack_public_path__ + "static/shadow_blade-660437e72b2709b44df1350dd066ec52.jpg";